module.exports = __webpack_public_path__ + "img/but_lobby_gift.d6c9c526.png";